export function removeUndefinedValues<T>(
    object: Record<string, T | undefined | null>
): Record<string, T> {
    return Object.fromEntries(
        Object.entries(object).filter(([_, value]) => value !== undefined && value !== null && value !== "")
    ) as Record<string, T>;
}

export function replaceUndefinedValues<T, V>(
    obj: Record<string, V | undefined>,
    replaceValue: T
): Record<string, T | V> {
    return Object.fromEntries(
        Object.entries(obj).map(([key, value]) => [key, value === undefined ? replaceValue : value])
    );
}

export function omitKeys<T, V>(obj: Record<string, V>, keys: string[]): Record<string, V> {
    return Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)));
}

export function pickKeys<T, V>(obj: Record<string, V>, keys: string[]): Record<string, V> {
    return Object.fromEntries(Object.entries(obj).filter(([k]) => keys.includes(k)));
}
